export const ThumbnailMockData = [
    'images/assigned-templates/report1.png',
    'images/assigned-templates/report2.png',
    'images/assigned-templates/report3.png',
    'images/assigned-templates/report4.png'
]